import { Spin } from 'antd';
import { LoadingOutlined } from '@ant-design/icons';
import styles from '../item-details.module.scss';
import { ShippingTimelineRow } from '../types';

interface Props {
  data: { timeline?: ShippingTimelineRow[] } | null;
  loading?: boolean;
}

const formatDateTime = (dateTime: string): string => {
  if (!dateTime) return '';
  const d = new Date(dateTime);
  if (isNaN(d.getTime())) return dateTime;
  const months = ['Jan', 'Feb', 'Mar', 'Apr', 'May', 'Jun', 'Jul', 'Aug', 'Sep', 'Oct', 'Nov', 'Dec'];
  const h = d.getHours();
  return `${months[d.getMonth()]} ${String(d.getDate()).padStart(2, '0')}, ${d.getFullYear()} ${h % 12 || 12}:${String(d.getMinutes()).padStart(2, '0')} ${h >= 12 ? 'PM' : 'AM'}`;
};

const ShippingTrackingView: React.FC<Props> = ({ data, loading }) => {
  const rows = data?.timeline ?? [];

  if (loading) {
    return (
      <div className={styles.shippingMiddleMessage}>
        <Spin indicator={<LoadingOutlined spin />} />
        <span>Loading...</span>
      </div>
    );
  }

  return (
    <div className={styles.shippingTableContainer}>
      <table className={styles.shippingTable}>
        <thead>
          <tr>
            <th>DATE/TIME</th>
            <th>ACTIVITY</th>
            <th>LOCATION</th>
          </tr>
        </thead>
        <tbody>
          {rows.length === 0 ? (
            <tr>
              <td colSpan={3} className={styles.shippingTableEmpty}>
                No tracking events available
              </td>
            </tr>
          ) : (
            rows.map((row, i) => (
              <tr key={i} className={i % 2 === 1 ? styles.shippingRowAlt : ''}>
                <td className={styles.shippingDateCell}>{formatDateTime(row.dateTime)}</td>
                <td className={styles.shippingActivityCell}>{row.event}</td>
                <td className={styles.shippingLocationCell}>{row.location}</td>
              </tr>
            ))
          )}
        </tbody>
      </table>
    </div>
  );
};

export default ShippingTrackingView;
